// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__Ldahv","question":"styles_question__2X5Xf"};